if (!customElements.get('product-in-action')) {
  customElements.define(
    'product-in-action',
    class ProductInAction extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.ProductInActionModal');
        this.track = this.querySelector('[data-in-action-track]');
        this.slides = [...this.querySelectorAll('[data-in-action-slide]')];
        this.count = this.querySelector('[data-in-action-count]');
        this.soundButton = this.querySelector('[data-in-action-sound]');
        this.productSlides = [...this.querySelectorAll('[data-in-action-product-slide]')];
        this.productIndex = 0;
        this.menu = this.querySelector('[data-in-action-menu]');
        this.menuToggle = this.querySelector('[data-in-action-menu-toggle]');
        this.currentIndex = 0;
        this.variantChangeUnsubscriber = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
          ? subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.updateCurrentVariant(event))
          : undefined;

        this.querySelectorAll('[data-in-action-open]').forEach((button) => {
          button.addEventListener('click', () => this.open(Number(button.dataset.inActionOpen)));
        });
        this.querySelector('[data-in-action-close]')?.addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-in-action-previous]')?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.querySelector('[data-in-action-next]')?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.soundButton?.addEventListener('click', () => this.toggleSound());
        this.querySelector('[data-in-action-product-previous]')?.addEventListener('click', () => this.goToProduct(this.productIndex - 1));
        this.querySelector('[data-in-action-product-next]')?.addEventListener('click', () => this.goToProduct(this.productIndex + 1));
        this.menuToggle?.addEventListener('click', () => this.toggleMenu());
        this.querySelector('[data-in-action-share]')?.addEventListener('click', () => this.share());
        this.querySelector('[data-in-action-copy-link]')?.addEventListener('click', () => this.copyLink());
        this.track?.addEventListener('scroll', () => this.updateCurrentFromScroll(), { passive: true });
        this.dialog?.addEventListener('close', () => this.pauseAll());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      updateCurrentVariant(event) {
        const variant = event?.data?.variant;
        if (event?.data?.sectionId !== this.dataset.sectionId || !variant) return;

        this.querySelectorAll('[data-in-action-current-variant]').forEach((input) => {
          input.value = variant.id;
          input.disabled = false;
        });

        this.querySelectorAll('[data-in-action-current-submit]').forEach((button) => {
          const isAvailable = variant.available;
          button.toggleAttribute('disabled', !isAvailable);
          button.setAttribute('aria-disabled', String(!isAvailable));
        });

        this.querySelectorAll('[data-in-action-current-submit-text]').forEach((text) => {
          text.textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        });
      }

      open(index) {
        if (!this.dialog.open) this.dialog.showModal();
        this.goTo(index, 'instant');
      }

      goTo(index, behavior = 'smooth') {
        if (!this.slides.length) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides[this.currentIndex].scrollIntoView({ behavior, block: 'start' });
        this.updateCount();
        this.pauseAll(this.currentIndex);
        const video = this.slides[this.currentIndex].querySelector('video');
        if (video) video.muted = true;
        this.updateSoundButton();
        video?.play().catch(() => {});
      }

      updateCurrentFromScroll() {
        if (!this.track || !this.slides.length) return;
        const index = Math.round(this.track.scrollTop / this.track.clientHeight);
        if (index === this.currentIndex || !this.slides[index]) return;
        this.currentIndex = index;
        this.updateCount();
        this.pauseAll(this.currentIndex);
        const video = this.slides[this.currentIndex].querySelector('video');
        if (video) video.muted = true;
        this.updateSoundButton();
        video?.play().catch(() => {});
      }

      updateCount() {
        if (this.count) this.count.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }

      toggleSound() {
        const video = this.slides[this.currentIndex]?.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        this.updateSoundButton();
      }

      updateSoundButton() {
        if (!this.soundButton) return;
        const isMuted = this.slides[this.currentIndex]?.querySelector('video')?.muted !== false;
        this.soundButton.setAttribute('aria-pressed', String(!isMuted));
      }

      goToProduct(index) {
        if (!this.productSlides.length) return;
        this.productIndex = (index + this.productSlides.length) % this.productSlides.length;
        this.productSlides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === this.productIndex));
      }

      toggleMenu() {
        const isOpen = this.menu?.hasAttribute('hidden') === false;
        this.menu?.toggleAttribute('hidden', isOpen);
        this.menuToggle?.setAttribute('aria-expanded', String(!isOpen));
      }

      async share() {
        const data = { title: document.title, url: window.location.href };
        if (navigator.share) {
          try { await navigator.share(data); } catch (_) {}
        } else {
          this.copyLink();
        }
      }

      async copyLink() {
        try { await navigator.clipboard.writeText(window.location.href); } catch (_) {}
        this.menu?.setAttribute('hidden', '');
        this.menuToggle?.setAttribute('aria-expanded', 'false');
      }

      pauseAll(exceptIndex) {
        this.slides.forEach((slide, index) => {
          if (index !== exceptIndex) slide.querySelector('video')?.pause();
        });
      }
    }
  );
}
